import React, { useEffect, useRef } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ContentSlider } from '../../common/ui';

const styles = cssMap({
	floatingPositioner: {
		position: 'fixed',
		bottom: token('space.100'),
		zIndex: 400,
		pointerEvents: 'none',
		display: 'flex',
		justifyContent: 'center',
		transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)',
	},
});

export const usePrevious = <T,>(value: T): T | undefined => {
	const ref = useRef<T | undefined>();
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
};

export const ToolbarWrapper = ({
	children,
	show,
	width,
	onDeselectAll,
}: {
	children: React.ReactNode;
	onDeselectAll?: () => void;
	show: boolean;
	width?: string;
}) => {
	const previousShow = usePrevious(show);

	useEffect(() => {
		if (previousShow && !show) {
			onDeselectAll?.();
		}
	}, [onDeselectAll, previousShow, show]);

	return (
		<Box xcss={styles.floatingPositioner} style={{ width: width || '100%' }}>
			<ContentSlider show={show}>{children}</ContentSlider>
		</Box>
	);
};
